import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrderHistoryComponent } from './order-history.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'default',
        component: OrderHistoryComponent,
        data: {
          title: "Order Management",
          breadcrumb: "Order Management"
        }
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderHistoryRoutingModule { }
